import { render } from "./ArticlesOverview.vue?vue&type=template&id=689e29f8"
import script from "./ArticlesOverview.vue?vue&type=script&lang=js"
export * from "./ArticlesOverview.vue?vue&type=script&lang=js"

import "./ArticlesOverview.vue?vue&type=style&index=0&id=689e29f8&lang=css"

import exportComponent from "E:\\moneyman\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__